import {
  getUnaryBooleanValue,
  MappingsProps,
  toExtendedOption,
} from "@hightouch/formkit";
import { SharedProps } from ".";
import { Mappings } from "src/formkit/components";
import { toExtendedAssociationOption } from "@hightouch/formkit/src/api/components/associationOption";

export const FKMappings = ({
  name,
  allEnabled,
  autoSyncColumnsDefault,
  allEnabledKey,
  allEnabledLabel,
  creatable,
  creatableTypes,
  options,
  error,
  advanced,
  enableInLineMapper,
  required,
  excludeMappings,
  associationOptions,
  templates,
  componentSupportsMatchBoosting,
  matchboosterSemanticColumnsToMap,
  allowCreatableAutomapperWithFields,
  allowIgnoreNullForAssociations,
  allowLookupConditions,
  supportOnlyWriteIfNull,
  spread,
  mappingTypes,
  isDisabled,
  query,
}: MappingsProps & {
  allEnabledKey?: string;
  allEnabledLabel?: string;
  associationOptions: any;
  creatable: any;
} & SharedProps) => (
  <Mappings
    // Remount when the name changes to reset the field state
    key={name}
    advanced={advanced}
    allEnabled={allEnabled}
    allEnabledKey={allEnabledKey}
    allEnabledLabel={allEnabledLabel}
    allowCreatableAutomapperWithFields={allowCreatableAutomapperWithFields}
    allowIgnoreNullForAssociations={allowIgnoreNullForAssociations}
    allowLookupConditions={allowLookupConditions}
    supportOnlyWriteIfNull={supportOnlyWriteIfNull}
    associationOptions={toExtendedAssociationOption(associationOptions)}
    asyncOptions={query.enabled}
    autoSyncColumnsDefault={autoSyncColumnsDefault}
    creatable={getUnaryBooleanValue(creatable)}
    creatableTypes={toExtendedOption(creatableTypes)}
    enableInLineMapper={enableInLineMapper}
    componentSupportsMatchBoosting={componentSupportsMatchBoosting}
    matchboosterSemanticColumnsToMap={matchboosterSemanticColumnsToMap}
    error={error}
    excludeMappings={excludeMappings}
    isDisabled={isDisabled}
    loading={query.isFetching}
    mappingTypes={mappingTypes}
    name={name}
    options={toExtendedOption(query.enabled ? query.data : options)}
    reload={query.refetch}
    required={required}
    spread={spread}
    templates={templates}
  />
);
